import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { HomeComponent } from './components/home/home.component';
// import { KannabysHomeComponent } from './components/kannabys-home/kannabys-home.component';

const routes: Routes = [
  // {
  //   path: 'home',
  //   component: HomeComponent,
  // },
  // {
  //   path: 'kannabys-home',
  //   component: KannabysHomeComponent,
  // },  

  // {
  //   path: 'swap',
  //   loadChildren: () => import('./pages/swap/swap.module').then(m => m.SwapModule),
  // },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
  },
  {
    path: 'mint',
    loadChildren: () => import('./pages/mint/mint.module').then(m => m.MintModule),
  },
  {
    path: 'claim',
    loadChildren: () => import('./pages/claim/claim.module').then(m => m.ClaimModule),
  },
  {
    path: 'claim-plants',
    loadChildren: () => import('./pages/claim-plants/claim-plants.module').then(m => m.ClaimPlantsModule),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'mint'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

